<template>
    <div id="summary">
        <div class="app-container mt-5 mb-5" v-if="!$global.loading">
            <div class="d-flex justify-content-between mb-5">
                <div class="d-flex">
                    <div class="category-btn mr-3">
                        <v-icon color="#FFFFFF" left class="pb-1">work</v-icon>
                        Entreprise
                    </div>

                    <div class="page-title mr-3">
                        {{ entity.name }}
                        <v-icon @click="prepareNameUpdate" class="ml-2 text-primary">edit</v-icon>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <div class="gap-15 d-flex flex-column">
                        <providers-bloc :entity-id="entityId"></providers-bloc>

                        <div class="d-flex flex-row">
                            <entity-contact-bloc :contact="entity.contact" :entityId="entity.id"
                                                 class="col-6 p-0 mr-2 h-auto">
                            </entity-contact-bloc>

                            <localisation-bloc class="col-6 ml-2 h-auto"
                              :localisation="entity.localisation">
                            </localisation-bloc>
                        </div>

                        <entity-tag-bloc :entity-id="entity.id"></entity-tag-bloc>
                    </div>
                </div>

                <div class="col-6 gap-15 d-flex flex-column">
                    <entity-contacts-bloc :entity-id="entity.id"></entity-contacts-bloc>
                    <entity-note :entity-id="entity.id" :entity-note="entity.note"></entity-note>
                    <entity-phone-calls-bloc :entity-id="entity.id"></entity-phone-calls-bloc>
                </div>
            </div>
        </div>

        <v-dialog v-model="updateNameModal" max-width="400" style="{ 'zIndex': 200 }"
                  @keydown.esc="updateNameModal = false">
            <v-card>
                <v-toolbar dense flat>
                    <v-toolbar-title class="mt-6 ml-2">Modification du nom de l'entreprise</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="p-4">
                    <v-text-field
                      outlined
                      label="Nom de l'entreprise"
                      v-model="newName"
                      hide-details
                      :class="{'input-error': newName === '' || newName === null}"
                    ></v-text-field>
                </v-card-text>

                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn @click="updateNameModal = false" class="mb-2 mr-2">
                        Annuler
                    </v-btn>
                    <v-btn class="default-button mr-3 mb-2" :disabled="newName === '' || newName === null"
                           @click="updateName">
                        Modifier
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex"
import LocalisationBloc from "./LocalisationBloc.vue"
import EntityContactBloc from "./EntityContactBloc.vue"
import EntityNote from "./EntityNote.vue"
import EntityPhoneCallsBloc from "./EntityPhoneCallsBloc.vue"
import ProvidersBloc from "./ProvidersBloc.vue"
import EntityTagBloc from "./EntityTagBloc.vue"
import EntityContactsBloc from "./EntityContactsBloc.vue"

export default {
    name: "Entity",
    components: {
        LocalisationBloc,
        EntityContactBloc,
        EntityNote,
        EntityPhoneCallsBloc,
        ProvidersBloc,
        EntityTagBloc,
        EntityContactsBloc,
    },
    data() {
        return {
            entityId: null,
            entity: null,
            newName: "",
            updateNameModal: false,
        }
    },
    methods: {
        getEntity() {
            this.$global.loading = true
            this.$http.get("auth/sit-entity/" + this.entityId).then(res => {
                this.entity = res.body.data.sitEntity

                this.$global.loading = false
            })
        },
        prepareNameUpdate() {
            this.newName = this.entity.name
            this.updateNameModal = true
        },
        updateName() {
            let payload = {
                entityId: this.entity.id,
                name: this.newName,
            }

            this.$http.put("auth/sit-entity/update-name", payload).then(res => {
                if (res.body.success) {
                    this.updateNameModal = false

                    this.getEntity()
                }
            })
        },
    },
    computed: {
        ...mapState("account", ["user", "account"]),
    },
    created() {
        this.$global.loading = true
        let hash = this.$route.params.hash
        this.entityId = parseInt(atob(hash))

        this.getEntity()

        this.$global.$on("reload-entity", () => {
            this.$global.loading = true
            this.getEntity()

            if(this.$refs.modale) {
                this.$refs.modale.cancel()
            }
        })
    },
    beforeDestroy() {
        this.$global.$off("reload-entity")
    },
}
</script>